export const titleMap = {
  '0': '导购商城',
  '1': '优惠券',
  '2': '导购任务',
  '3': '历史业绩',
  '4': '订单处理',
  '5': '离职客户继承'
}

const DHIcons = [
  require('@/assets/img/guideShopshelf/default_img/shouye-selected.png'),
  require('@/assets/img/guideShopshelf/default_img/huiyuan1-selected.png'),
  require('@/assets/img/guideShopshelf/default_img/huodong1-selected.png'),
  require('@/assets/img/guideShopshelf/default_img/User_on.png')
]
const DIcons = [
  require('@/assets/img/guideShopshelf/default_img/shouye.png'),
  require('@/assets/img/guideShopshelf/default_img/huiyuan1.png'),
  require('@/assets/img/guideShopshelf/default_img/huodong1.png'),
  require('@/assets/img/guideShopshelf/default_img/User.png')
]
export const defalutTabbars = [
  {
    label: '首页',
    icon: '',
    iconHighlight: '',
    default: '首页',
    defaultHighIcon: DHIcons[0],
    defaultIcon: DIcons[0]
  },
  {
    label: '名片',
    icon: '',
    iconHighlight: '',
    default: '名片',
    defaultHighIcon: DHIcons[1],
    defaultIcon: DIcons[1]
  },
  {
    label: '客户',
    icon: '',
    iconHighlight: '',
    default: '客户',
    defaultHighIcon: DHIcons[2],
    defaultIcon: DIcons[2]
  },
  {
    label: '客户群',
    icon: '',
    iconHighlight: '',
    default: '客户群',
    defaultHighIcon: DHIcons[3],
    defaultIcon: DIcons[3]
  }
]

export const defaultThemeColors = [
  { id: 1, label: '风格1', primaryColor: '#ff0000', secondaryColor: '#00ff00' },
  { id: 2, label: '风格2', primaryColor: '#ff0000', secondaryColor: '#00ff00' },
  { id: 3, label: '风格3', primaryColor: '#ff0000', secondaryColor: '#00ff00' }
]
const DMIcons = [
  require('@/assets/img/guideShopshelf/default_img/shopping-bag.png'),
  require('@/assets/img/guideShopshelf/default_img/Coins.png'),
  require('@/assets/img/guideShopshelf/default_img/grid.png'),
  require('@/assets/img/guideShopshelf/default_img/Piggy.png'),
  require('@/assets/img/guideShopshelf/default_img/order.png'),
  require('@/assets/img/guideShopshelf/default_img/A-5.png')
]
export const defaultMenus = [
  { name: '我的云店', icon: '', default: '我的云店', defaultMenusIcon: DMIcons[0] },
  { name: '优惠券', icon: '', default: '优惠券', defaultMenusIcon: DMIcons[1] },
  { name: '导购任务', icon: '', default: '导购任务', defaultMenusIcon: DMIcons[2] },
  { name: '历史业绩', icon: '', default: '历史业绩', defaultMenusIcon: DMIcons[3] },
  { name: '客户分配', icon: '', default: '客户分配', defaultMenusIcon: DMIcons[4] },
  { name: '订单处理', icon: '', default: '订单处理', defaultMenusIcon: DMIcons[5] }
]
const DBImgs = [
  require('@/assets/img/guideShopshelf/default_img/sybg.jpg'),
  require('@/assets/img/guideShopshelf/default_img/rankbg.png'),
  require('@/assets/img/guideShopshelf/default_img/scardbg.jpg')
]
export const defaultBrand = {
  cover: { label: '首页封面', type: 2, bgk: '', config: {}, defaultMenusImg: DBImgs[0] },
  rank: { label: '业绩排名背景', type: 2, bgk: '', config: {}, defaultMenusImg: DBImgs[1] },
  qrcode: { label: '名片背景', type: 2, bgk: '', config: {}, defaultMenusImg: DBImgs[2] }
}
export const defalutData = {
  global: {
    style: {
      config: {
        textColor: { type: 1, color: '#000' },
        themeColor: { type: 1, primaryColor: '#000', sencondColor: '#333' }
      },
      default: { textColor: '#000', styleColor: { type: 1 } }
    },
    tabbar: {
      config: [],
      default: { name: '我的客户', bkg: '', bkg_h: 100 }
    }
  },
  index: {
    menu: {
      config: [],
      default: { name: '导航4', icon: '' }
    },
    cover: {
      background: {
        config: {
          bgk: '',
          img: '',
          label: '名片背景',
          type: 2,
          default: { bgk: '' }
        }
      }
    },
    rank: {
      background: {
        config: {
          bgk: '',
          img: '',
          label: '名片背景',
          type: 2,
          default: { bgk: '' }
        }
      }
    }
  },
  qrcode: {
    background: {
      config: {
        bgk: '',
        img: '',
        label: '名片背景',
        type: 2,
        defaultMenusImg: DBImgs[2],
        default: { bgk: '' }
      }
    }
  }
}

export default {
  defalutTabbars,
  defaultThemeColors,
  defaultMenus,
  defaultBrand,
  defalutData,
  titleMap
}
